import { vietmeetLocalStorage } from '@vietmeet/js-utils';
import { isOnline } from '../net-info/selectors';
import VietMeetJS from './_';
import { LIB_DID_DISPOSE, LIB_DID_INIT, LIB_INIT_ERROR, LIB_WILL_DISPOSE, LIB_WILL_INIT } from './actionTypes';
import { isAnalyticsEnabled } from './functions.any';
import logger from './logger';
/**
 * Disposes (of) vietmeet-lib.
 *
 * @returns {Function}
 */
export function disposeLib() {
    return (dispatch) => {
        dispatch({ type: LIB_WILL_DISPOSE });
        // TODO Currently, vietmeet-lib doesn't have the functionality to
        // dispose itself.
        dispatch({ type: LIB_DID_DISPOSE });
    };
}
/**
 * Initializes vietmeet-lib (i.e. {@link invokes VietMeetJS.init()}) with the
 * current config(uration).
 *
 * @returns {Function}
 */
export function initLib() {
    return (dispatch, getState) => {
        const state = getState();
        const config = state['features/base/config'];
        if (!config) {
            throw new Error('Cannot init vietmeet-lib without config');
        }
        dispatch({ type: LIB_WILL_INIT });
        try {
            VietMeetJS.init({
                enableAnalyticsLogging: isAnalyticsEnabled(getState),
                ...config,
                externalStorage: vietmeetLocalStorage.isLocalStorageDisabled() ? vietmeetLocalStorage : undefined
            });
            VietMeetJS.setNetworkInfo({
                isOnline: isOnline(state)
            });
            logger.info(`vietmeet-lib version: ${VietMeetJS.version}`);
            logger.info(`User Agent: ${navigator.userAgent}`);
            dispatch({ type: LIB_DID_INIT });
        }
        catch (error) {
            dispatch(libInitError(error));
        }
    };
}
/**
 * Notifies about a specific error raised by {@link VietMeetJS.init()}.
 *
 * @param {Error} error - The Error raised by VietMeetJS.init().
 * @returns {{
 *     type: LIB_INIT_ERROR,
 *     error: Error
 * }}
 */
export function libInitError(error) {
    return {
        type: LIB_INIT_ERROR,
        error
    };
}
